import type AuthStore from "../authentication/AuthStore.tsx";
import {environment} from "../env.ts";

export type UnderConstructionOptions =
    true // App is always under construction
    | 'for-end-users' // App is only under construction for non Mithra users
    | 'for-non-staff' // App is only under construction for non Staff users
    | undefined // App is not under construction
    ;

export function isUnderConstructionMode(authStore?: AuthStore): boolean {
    if (environment.isUnderConstruction === 'for-end-users') {
        if (!authStore) return true;
        return !authStore.isMithraStaff;
    }
    if (environment.isUnderConstruction === 'for-non-staff') {
        if (!authStore) return true;
        return !authStore.isMithraStaffGroup;
    }
    return Boolean(environment.isUnderConstruction);

}
